import { useState, useEffect, useCallback } from 'react';
import api from '../../../api/api';
import { handleRequestHelper } from '../../../utils/helpers';
import { useNotifications } from '../../../Providers/NotificationsProvider/NotificationsProvider';
import { PAYMENT_METHODS } from '../../../constants/types';

export const usePaymentMethods = (eventId, userCountry) => {
  const { showNotification } = useNotifications();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);
  const [showInternationalCardWarning, setShowInternationalCardWarning] = useState(false);
  const [paymentMethodSelectedIndex, setPaymentMethodSelectedIndex] = useState(null);

  const getPaymentMethods = useCallback(async () => {
    setLoadingPaymentMethods(true);

    await handleRequestHelper({
      endpoint: () => api.getEventPaymentMethodsByEventId(eventId, userCountry),
      onSuccess: ({ paymentMethods }) => {
        setPaymentMethods(paymentMethods);
        setShowInternationalCardWarning(
          userCountry !== 'AR' &&
            paymentMethods.some((pm) => pm.method === PAYMENT_METHODS.MERCADO_PAGO)
        );
        if (paymentMethods.length > 0) {
          setPaymentMethodSelectedIndex(0);
        } else {
          showNotification('No hay métodos de pago disponibles para este evento', 'error');
          setPaymentMethodSelectedIndex(null);
        }
      },
      showNotification,
    });

    setLoadingPaymentMethods(false);
  }, [eventId, userCountry, showNotification]);

  useEffect(() => {
    getPaymentMethods();
  }, [getPaymentMethods]);

  return {
    paymentMethods,
    loadingPaymentMethods,
    showInternationalCardWarning,
    paymentMethodSelectedIndex,
    setPaymentMethodSelectedIndex,
  };
};
